/**
 * @module cercaliagl/view/VLogisticRestrictions
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import { MDCTextField } from '@material/textfield';
import { MDCCheckbox } from '@material/checkbox';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
import { createCheckboxIconInput, } from './VUtils';
/**
  * @enum {string}
  */
export var EventType = {
    CHANGE: 'change',
    CLOSE: 'close',
};
/**
 * @enum {string}
 */
export var LogisticsIcons = {
    VAXLEWEIGHT: '<span class="icon-vaxleweight"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
    VMAXVEL: '<span class="icon-velmax"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
    VHEIGHT: '<span class="icon-vheight"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>',
    VLENGTH: '<span class="icon-vlength"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
    VWIDTH: '<span class="icon-vwidth"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>',
    VWEIGHT: '<span class="icon-lweight"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>',
    RIMP: '<span class="icon-rimp"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>',
};
/**
  * @classdesc
  */
var VLogisticRestrictions = /** @class */ (function (_super) {
    __extends(VLogisticRestrictions, _super);
    /**
      * @constructor
      */
    function VLogisticRestrictions() {
        var _this = this;
        var jqElement = $("\n    <div class=\"v-logistics mdc-elevation--z4\">\n    <div class=\"log-params\">\n    <div class=\"title\">".concat(i18n('showRoadRestrictions'), "</div>\n      <div class=\"row\">\n        <div class='column'>\n          ").concat(createCheckboxIconInput('lweight', i18n('maxWeight'), LogisticsIcons.VWEIGHT, false), "\n        </div>\n        <div class='column'>\n          ").concat(createCheckboxIconInput('llength', i18n('maxLength'), LogisticsIcons.VLENGTH, false), "\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class='column'>\n          ").concat(createCheckboxIconInput('lweightaxl', i18n('maxAxleWeight'), LogisticsIcons.VAXLEWEIGHT, false), "\n        </div>\n        <div class='column'>\n          ").concat(createCheckboxIconInput('lwidth', i18n('maxWidth'), LogisticsIcons.VWIDTH, false), "             \n        </div>\n      </div>\n      <div class=\"row\">\n        <div class='column'>\n          ").concat(createCheckboxIconInput('lheight', i18n('maxHeight'), LogisticsIcons.VHEIGHT, false), "\n        </div>\n        <div class='column rimpColumn'>\n          ").concat(createCheckboxIconInput('rimp', i18n('dangerousGoods'), LogisticsIcons.RIMP, false, false), "\n        </div>\n      </div>\n      </div>\n  </div>\n     "));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {LogisticsParams}
         */
        _this.logisticsParams_ = {};
        _this.initialize_();
        return _this;
    }
    /**
      * @override
      */
    VLogisticRestrictions.prototype.show = function () {
        this.jqElement_.show();
    };
    /**
     * @param {boolean=} opt_animation Animation
     */
    VLogisticRestrictions.prototype.hide = function (animation) {
        if (animation === void 0) { animation = true; }
        if (animation !== true) {
            this.jqElement_.hide();
        }
        else {
            this.jqElement_.fadeOut();
        }
    };
    /**
      * @private
      */
    VLogisticRestrictions.prototype.initialize_ = function () {
        this.initializeLogisticsParams_();
    };
    /**
     * Normalize values depending parameters.
     * - Lenghts must be in cm.
     * - Other values must be float without convertion.
     * @private
     * @param {string} param Parameter
     * @param {string} value Value
     * @param {boolean} checked Checkbox checked or not
     * @return {number}
     */
    VLogisticRestrictions.prototype.normalizeParamNameValue_ = function (param, value, checked) {
        if (checked && value.length > 0) {
            this.logisticsParams_[param] = ['lheight', 'llength', 'lwidth'].indexOf(param) !== -1 ? parseFloat(value, 10) * 100 : parseFloat(value);
        }
        else {
            delete this.logisticsParams_[param];
        }
    };
    /**
     * @private
     */
    VLogisticRestrictions.prototype.initializeLogisticsParams_ = function () {
        var _this = this;
        if (!this.jqElement_) {
            return;
        }
        var jqDivLogisticsParams = this.jqElement_.find('.log-params');
        if (!jqDivLogisticsParams) {
            return;
        }
        jqDivLogisticsParams.find('.mdc-text-field').each(function (i, textField) {
            var mdcTextField = new MDCTextField(textField);
            var mdcCheckbox = new MDCCheckbox(textField.parentElement.querySelector('.mdc-checkbox'));
            $(textField)
                .find('input')
                .on('input', function (e) {
                var _a;
                if ((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.includes(',')) {
                    e.target.value = e.target.value.replace(',', '.');
                }
                _this.normalizeParamNameValue_(e.target.name, e.target.value, mdcCheckbox.checked);
                _this.emit(EventType.CHANGE, _this.logisticsParams_);
            })
                .click(function (e) {
                mdcCheckbox.checked = !mdcCheckbox.checked;
                _this.normalizeParamNameValue_(e.target.name, e.target.value, mdcCheckbox.checked);
                _this.emit(EventType.CHANGE, _this.logisticsParams_);
            });
            mdcCheckbox.listen('change', function (e) {
                _this.normalizeParamNameValue_(e.target.name, mdcTextField.value, mdcCheckbox.checked);
                _this.emit(EventType.CHANGE, _this.logisticsParams_);
            });
            var mdcCheckboxRimp = new MDCCheckbox(jqDivLogisticsParams.find('.mdc-form-field.rimp').get(0));
            mdcCheckboxRimp.listen('change', function () {
                _this.logisticsParams_.rimp = mdcCheckboxRimp.checked;
                _this.emit(EventType.CHANGE, _this.logisticsParams_);
            });
        });
    };
    VLogisticRestrictions.prototype.reset = function () {
        var _this = this;
        var jqDivLogisticsParams = this.jqElement_.find('.log-params');
        jqDivLogisticsParams.find('input').each(function (i, textField) {
            if ($(textField).hasClass('mdc-checkbox__native-control')) {
                $(textField).prop('checked', false);
            }
            else if ($(textField).hasClass('mdc-text-field__input')) {
                $(textField).val('');
                $(textField).removeAttr('filled');
            }
        });
        var floatingLabels = jqDivLogisticsParams.find('.mdc-floating-label');
        if (floatingLabels) {
            floatingLabels.each(function (i, textField) {
                textField.setAttribute('class', 'mdc-floating-label');
            });
        }
        var paramsKeys = Object.keys(this.logisticsParams_);
        if (paramsKeys) {
            paramsKeys.forEach(function (key) {
                _this.logisticsParams_[key] = undefined;
            });
        }
    };
    return VLogisticRestrictions;
}(BaseView));
export default VLogisticRestrictions;
//# sourceMappingURL=VLogisticRestrictions.js.map